import * as s from "../../VideoGuideStyled";
import { Text } from "components/atoms/text/Text";
import { COLORS } from "styles/colors";
import { HelpGuide } from "hook/useHelpGuideApi";

interface TableListItemProps {
  guide: HelpGuide;
  onClickGuideItem: (guide: HelpGuide) => void;
}
export default function ListItemYoutube({
  guide,
  onClickGuideItem,
}: TableListItemProps) {
  return (
    <s.VideoItem
      onClick={() => onClickGuideItem(guide)}
      data-testid="help-video-guides-item-video-item-click-guide-item"
    >
      <s.VideoThumbnail>
        {/* <ImageLabel time>02:04</ImageLabel> */}
        <img src={guide.thumbnailUrl} alt="youtube thumbnail" />
      </s.VideoThumbnail>
      <Text className="title" bold>
        {guide.title}
      </Text>
      <Text color={COLORS.BUTTONS1} fontSize={14}>
        {guide.description}
      </Text>
    </s.VideoItem>
  );
}
